import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'shopping-list',
                label: 'Lista de Compras',
                routerLink: ['/extensions/shopping-list'],
                icon: 'checkbox-list',
                requiresPermission: (userPermissions) =>
                    userPermissions.includes('ReadShoppingList'),
            },
            'customers'
        ),
    ],
})
export class ShoppingListNavModule {}
